export enum ActionType {
  REVENUE_GC_DETAILS_BY_PID = "REVENUE_GC_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IRevenueGCDetailsByPid {
  type: ActionType.REVENUE_GC_DETAILS_BY_PID;
  payload: any;
}

export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IRevenueGCDetailsByPid | IResetReduxState;
